"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-comment */
const jquery_1 = __importDefault(require("jquery"));
// @ts-ignore
const bootstrap_additions_1 = __importDefault(require("./bootstrap_additions"));
// @ts-ignore
const widgets_1 = __importDefault(require("./widgets"));
// @ts-ignore
const admin_common_1 = __importDefault(require("./plugins/admin_common"));
// @ts-ignore
const ajaxhandler_1 = __importDefault(require("./plugins/ajaxhandler"));
// @ts-ignore
const smartactions_1 = __importDefault(require("./plugins/smartactions"));
// @ts-ignore
const piecharts_1 = __importDefault(require("./plugins/piecharts"));
const timespanpicker_1 = __importDefault(require("./plugins/timespanpicker"));
const SymfonyCollection_1 = __importDefault(require("./plugins/SymfonyCollection"));
const SymfonyTableCollection_1 = __importDefault(require("./plugins/SymfonyTableCollection"));
// @ts-ignore
const sparklines_1 = __importDefault(require("./plugins/sparklines"));
// @ts-ignore
const datatables_1 = __importDefault(require("./datatables"));
// @ts-ignore
const plotcharts_1 = __importDefault(require("./plugins/plotcharts"));
// @ts-ignore
const libs_1 = __importDefault(require("./libs"));
// @ts-ignore
const plugins_1 = __importDefault(require("./plugins"));
const interfaces_1 = require("./plugins/interfaces");
require("../notification/SmartNotification");
class App {
    constructor(settings) {
        this.settings = settings;
        this.services = {};
        this.serviceList = [];
        this.isPageInitialized = false;
        this.getService = (name) => {
            if (this.services[name]) {
                return this.services[name];
            }
            return undefined;
        };
        this.loadAndRegister = (name, plugin, priority = 0) => {
            plugins_1.default.register(name, plugin);
            this.registerService(name, priority);
        };
        this.registerService = (name, priority = 0) => {
            if (!this.services[name]) {
                const plugin = plugins_1.default.get(name);
                if (plugin) {
                    this.services[name] = new plugin(this, this.settings[name] || {});
                }
                this.services[name].priority = priority;
                this.serviceList = Object.entries(this.services).sort((a, b) => (a[1].priority || 0) - (b[1].priority || 0));
                // Services die nach Seitenload registriert wurden sofort initialisieren
                if (this.isPageInitialized) {
                    this.services[name].init();
                }
            }
            if (typeof this.services[name] !== "object") {
                window.console.warn(`Warning: Unable to register service "${name}".`);
            }
        };
        this.init = () => {
            this.loadAndRegister("Widgets", widgets_1.default);
            this.loadAndRegister("BootstrapAdditions", bootstrap_additions_1.default);
            this.loadAndRegister("AdminCommon", admin_common_1.default);
            this.loadAndRegister("AjaxHandler", ajaxhandler_1.default);
            this.loadAndRegister("SmartActions", smartactions_1.default);
            this.loadAndRegister("PieCharts", piecharts_1.default);
            this.loadAndRegister("TimeSpanPicker", timespanpicker_1.default);
            this.loadAndRegister("PlotCharts", plotcharts_1.default);
            this.loadAndRegister("Sparklines", sparklines_1.default);
            this.loadAndRegister("DataTables", datatables_1.default);
            this.loadAndRegister("SymfonyFormCollection", SymfonyCollection_1.default);
            this.loadAndRegister("SymfonyFormTableCollection", SymfonyTableCollection_1.default);
            Object.keys(libs_1.default).forEach(name => this.loadAndRegister(name, libs_1.default[name]));
            (0, jquery_1.default)(window).on("app:content-changed", () => {
                this.pageDestroy();
                this.pageInit();
            });
            this.pageInit();
        };
        this.pageInit = () => {
            if (this.isPageInitialized) {
                this.pageDestroy();
            }
            this.isPageInitialized = true;
            this.serviceList.forEach(([plugin, item]) => {
                try {
                    item.init();
                }
                catch (e) {
                    if (window.console) {
                        window.console.error(`Error executing init of Plugin ${plugin}`, e);
                    }
                }
            });
        };
        this.pageDestroy = () => {
            this.isPageInitialized = false;
            this.serviceList.forEach(([plugin, item]) => {
                if (item.destroy && typeof item.destroy === "function") {
                    try {
                        item.destroy();
                    }
                    catch (e) {
                        if (window.console) {
                            window.console.error(`Error executing destroy of Plugin ${plugin}`, e);
                        }
                    }
                }
            });
        };
        this.pageAbort = (force = false) => {
            this.serviceList.forEach(([_, item]) => {
                if (item.abort && typeof item.abort === "function") {
                    try {
                        item.abort(force);
                    }
                    catch (e) {
                        if (window.console) {
                            window.console.error(e);
                        }
                    }
                }
            });
        };
        this.goTo = (url) => {
            if (Object.keys(this.services).includes("AjaxHandler")) {
                this.services.AjaxHandler.goTo(url);
            }
            else {
                window.location.href = url;
            }
        };
        this.displayNotification = (title, content, type, timeout) => {
            let color = "#5384af";
            let icon = "";
            if (type === "error") {
                color = "#c46a69";
                icon = "fa fa-warning";
            }
            jquery_1.default.smallBox({
                title,
                content,
                color,
                timeout,
                icon
            });
        };
    }
    partialInit(node) {
        if (!node) {
            return;
        }
        this.serviceList.forEach(([plugin, item]) => {
            if (!(0, interfaces_1.isDynamicContentPlugin)(item)) {
                return;
            }
            try {
                item.refresh(node);
            }
            catch (e) {
                if (window.console) {
                    window.console.error(`Error executing refresh of Plugin ${plugin}`, e);
                }
            }
        });
    }
}
const AppWrapper = (function (window, appConfig) {
    if (window.App) {
        // Dies kann auftreten wenn wegen Encore.enableSingleRuntimeChunk() die runtime.js durch AJAX ein
        // weiteres mal ausgeführt wird.
        console.warn("App was already initialized. Do not include smartadmin-app multiple times!");
        return window.App;
    }
    jquery_1.default.Deferred.exceptionHook = function (error, stack) {
        if (window.console && window.console.error && error) {
            window.console.error(error.message, error.stack, stack);
        }
    };
    /**
     * Application Initialization
     */
    const Application = new App(appConfig);
    (0, jquery_1.default)(Application.init);
    return Application;
}(window, window.appConfig || {}));
exports.default = AppWrapper;
window.App = AppWrapper;
